'use client';

import {LanguageTypes} from '@damascus-components/LetzChat';
import {getCurrentLanguage} from './translate.utils';
import {Route} from '@constants/appRoutes';

export const ROUTES = {
  HOME: Route.HOME(),
  UNITS: Route.UNITS(),
  COMMUNITIES: Route.COMMUNITIES(),
  DESTINATION: '/destination',
  RETAIL: Route.RETAIL(),
  PRIVACY_POLICY: Route.PRIVACY_POLICY(),
  CARPARKING: Route.PREMIUM_PARKING(),
  AFTERCARE: Route.ALDAR_AFTERCARE(),
  RESALE: Route.RESALE(),
  LOGISTICS: Route.LOGISTIC_CENTERS(),
  TESAREEH: Route.TASAREEH(),
};
export const BASE_PATH = [
  //'/' or Route.HOME() cannot be used this will match all paths on the logic below
  Route.UNITS(),
  Route.COMMUNITIES(),
  '/destination',
  Route.PRIVACY_POLICY(),
  Route.RETAIL(),
  Route.ALDAR_AFTERCARE(),
  Route.PREMIUM_PARKING(),
];
export const DEFAULT_LANG = 'en';

export const getAppRouteWithBasePath = (path: string) => {
  return `${process.env.NEXT_PUBLIC_APP_HOMEPAGE}${path}`;
};

export function getNewLanguageRoute(
  pathname: string,
  languageCode: LanguageTypes
) {
  const pathArray = pathname.split('/');
  const pathArrAccountingBasePath = pathArray;
  const newPathArray = pathArrAccountingBasePath.map((path, index) =>
    index === 1 ? languageCode : path
  );
  return newPathArray.join('/');
}

export function getAppRoute(route: keyof typeof ROUTES, routeTrail?: string) {
  return `/${getCurrentLanguage()}${ROUTES[route]}${routeTrail ?? ''}`;
}
